import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { graphic } from "echarts";
import { AuthMe } from "../lib/MyHttp";
import ECharts, { EChartsReactProps } from "echarts-for-react";
import useClientStore from "../stores/client";
import { useTranslation } from "react-i18next";
import alarm from "../assets/sound/beep1.mp3";
import { GetListLast } from "../lib/DeviceData";
import { calculateAge, checkCanPlay, gapTime, typeSex } from "../lib/Common";
import { Get, SearchDevice } from "../lib/Device";
import moment from "moment";

import axios from "axios";

import UnUseIcon from "../assets/block.gif";
import UseIcon_c from "../assets/chair_use.gif";
import UseIcon_m from "../assets/location.gif";
import UseIcon_b from "../assets/goto_sleep.gif";
import UseIcon_s from "../assets/pillow.gif";
import Apnea_icon from "../assets/insomnia.gif";

import ttsAudio from "../assets/sound/tts_07.mp3";
import ttsAudio_en from "../assets/sound/en/7.mp3";
import ttsAudio_jp from "../assets/sound/jp/7.mp3";
import ttsAudio_cn from "../assets/sound/cn/7.mp3";
import ttsAudio_mn from "../assets/sound/mn/8.mp3";

import BGM from "../assets/sound/MP_1.mp3";

import { Progress } from "antd";

const Start = () => {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();

    const { client, addOnMessage, removeOnMessage } = useClientStore();
    const [audio] = useState(new Audio(alarm));
    const [canPlay, setCanPlay] = useState(false);
    const [myInfo, setMyInfo] = useState(false);

    const audioRef = useRef(null);
    const bgmRef = useRef(null);

    const { name } = useParams();
    const { sex } = useParams();
    const { birth } = useParams();
    const { feel } = useParams();
    const { height } = useParams();
    const { weight } = useParams();
    const { device_no } = useParams();
    const { device_sn } = useParams();
    const { member_no } = useParams();
    const doneRef = useRef(false);

    const topicRef = useRef("");
    const oldRespRef = useRef(0);
    const oldHeartRef = useRef(0);
    const lastMessageAtRef = useRef(0);

    const LIGHT_API = "http://127.0.0.1:18790";

    const [data, setData] = useState({});
    const [Device, setDevice] = useState({});
    const [ids, setID] = useState(0);

    const startGradient = async () => {
        try {
            await axios.post(`${LIGHT_API}/light/measuring`, {}, { timeout: 800 });
        } catch (e) {
            console.warn("Local light measuring skipped");
        }
    };

    useEffect(() => {
        AuthMe(res => {
            setData(res);
        });
    }, []);

    useEffect(() => {
        const audio = audioRef.current;
        if (audio) {
            audio.play().catch(err => {
                console.warn("Autoplay failed:", err);
            });
        }

        const bgm = bgmRef.current;
        if (bgm) {
            bgm.volume = 0.25;
            bgm.loop = true;
            bgm.play().catch(err => {
                console.warn("BGM autoplay failed:", err);
            });
        }
    }, []);

    const [values1, setValues1] = useState([]);
    const [label1, setLabel1] = useState([]);
    const [value1, setValue1] = useState(0);

    const [values2, setValues2] = useState([]);
    const [label2, setLabel2] = useState([]);
    const [value2, setValue2] = useState(0);

    const [values3, setValues3] = useState([]);
    const [label3, setLabel3] = useState([]);
    const [value3, setValue3] = useState(0);

    const [value4, setMotionDetected] = useState(0);

    const onMessage = (topic, message) => {
        if (topicRef.current !== topic) {
            return;
        }

        try {
            const msg = JSON.parse(message);
            if (msg.e) {
                lastMessageAtRef.current = Date.now();
                procData(data, msg.e);
            }
        } catch (e) {
            console.error("MQTT message parse error", e);
        }
    };

    useEffect(() => {
        if (!client || !data?.device_sn) return;

        const topic = `SmartMat/${data.device_sn}/Autowells-server/pub_device_data`;
        topicRef.current = topic;

        client.subscribe(topic, error => {
            if (error) {
                return;
            }
        });

        addOnMessage(topic, onMessage);

        return () => {
            removeOnMessage(topic);

            client.unsubscribe(topic, error => {
                if (error) {
                    return;
                }
            });
        };
    }, [client, data?.device_sn]);

    useEffect(() => {
        loadLastData();
        startGradient();

        AuthMe(res => {
            setMyInfo(res);
            topicRef.current = `SmartMat/${res.device_sn}/Autowells-server/pub_device_data`;
        });

        return () => {
            try {
                if (bgmRef.current) {
                    bgmRef.current.pause();
                    bgmRef.current.currentTime = 0;
                }
            } catch {}

            if (audio) audio.pause();
        };
    }, []);

    useEffect(() => {
        const timer = setInterval(() => {
            const diff = Date.now() - lastMessageAtRef.current;
            const online = diff < 5000;

            setData(prev => {
                if (!prev || Object.keys(prev).length === 0) return prev;
                if (prev.online === online) return prev;
                return { ...prev, online };
            });
        }, 1000);

        return () => clearInterval(timer);
    }, []);

    const loadLastData = () => {
        // GetListLast({ id: id }, res => {
        //     if (res.length > 0) {
        //         const times = res.map(x => moment(x.time).format("mm:ss"));
        //         setValues1(res.map(x => x.heart));
        //         setValues2(res.map(x => x.resp));
        //         setValues3(res.map(x => x.apnea));
        //         setLabel1(times);
        //         setLabel2(times);
        //         setLabel3(times);
        //         setValue1(res[res.length - 1].heart);
        //         setValue2(res[res.length - 1].resp);
        //         setValue3(res[res.length - 1].apnea);
        //     }
        // });
    };

    useEffect(() => {}, []);

    const SEC = 60;
    const [percent, setPercent] = useState(0);

    const [date, setDate] = useState(moment().format("YYYY-MM-DD HH:mm:ss"));

    const start_date = moment(date).utc().format("YYYY-MM-DD HH:mm:ss");

    useEffect(() => {
        const totalMilliseconds = SEC * 1000;
        const intervalMilliseconds = 150;
        const progressIncrement = 100 / (totalMilliseconds / intervalMilliseconds);

        const interval = setInterval(() => {
            setPercent(prevPercent => {
                if (prevPercent >= 100) {
                    if (!doneRef.current) {
                        doneRef.current = true;
                        clearInterval(interval);
                        axios.post(`${LIGHT_API}/light/idle`, {}, { timeout: 800 }).catch(() => {});
                        sendData();
                    }
                    return 100;
                }
                return prevPercent + progressIncrement;
            });
        }, intervalMilliseconds);

        return () => clearInterval(interval);
    }, []);

    const sendData = () => {
        var end_date = moment(Date.now()).utc().format("YYYY-MM-DD HH:mm:ss");

        navigate("/result_ready", {
            state: {
                device_sn: `${device_sn}`,
                device_no: `${device_no}`,
                member_no: `${member_no}`,
                name: `${name}`,
                sex: `${sex}`,
                birth: `${birth}`,
                feel: `${feel}`,
                height: `${height}`,
                weight: `${weight}`,
                start: `${start_date}`,
                end: `${end_date}`
            }
        });
    };

    const procData = (data, recieveData) => {
        var heart = recieveData[0];
        var resp = recieveData[1];
        var apnea = recieveData[2];
        var state = recieveData[3];
        var fsr_sum = recieveData[4];
        var motion_detected = 0;

        if (resp < 9) {
            resp = oldRespRef.current;
        } else {
            oldRespRef.current = resp;
        }

        if (heart < 56) {
            heart = oldHeartRef.current;
        } else {
            oldHeartRef.current = heart;
        }

        if (data) {
            if (recieveData.length >= 11) {
                motion_detected = recieveData[11];
                setMotionDetected(motion_detected);
            }

            if (!data.resp_range_from) {
                data.heart_range_from = 60;
                data.heart_range_to = 100;
                data.resp_range_from = 10;
                data.resp_range_to = 20;
            }

            if (!data.online) {
                data.online = true;
                data.connectTime = moment();

                const heart_ranges = data.heart_range?.split("~");
                if (heart_ranges?.length >= 2) {
                    data.heart_range_from = heart_ranges[0];
                    data.heart_range_to = heart_ranges[1];
                }

                const resp_ranges = data.resp_range?.split("~");
                if (resp_ranges?.length >= 2) {
                    data.resp_range_from = resp_ranges[0];
                    data.resp_range_to = resp_ranges[1];
                }

                setData({ ...data });
            }

            const isUse = fsr_sum >= 300;
            if (isUse) {
                if (canPlay && myInfo?.on_sound === "Y" && audio) {
                    if (heart < data.heart_range_from || heart > data.heart_range_to || resp < data.resp_range_from || resp > data.resp_range_to) {
                        audio.loop = true;
                        audio.play();
                    } else {
                        audio.pause();
                    }
                }
            } else {
                if (canPlay && myInfo?.on_sound === "Y" && audio) {
                    audio.pause();
                }
                heart = 0;
                resp = 0;
                apnea = 0;
                state = 0;
            }
        }

        const time = moment().format("mm:ss");
        setValue1(heart);
        setValue2(resp);
        setValue3(fsr_sum);

        setValues1(prev => [...prev, heart].slice(-60));
        setValues2(prev => [...prev, resp].slice(-60));
        setValues3(prev => [...prev, fsr_sum].slice(-60));

        setLabel1(prev => [...prev, time].slice(-60));
        setLabel2(prev => [...prev, time].slice(-60));
        setLabel3(prev => [...prev, time].slice(-60));
    };

    const heartColor = "#F75C5D";
    const breathColor = "#3889ff";
    const oxygenColor = "#3fd3d4";

    const getOption1 = () => {
        return {
            tooltip: {
                trigger: "axis",
                axisPointer: {
                    lineStyle: {
                        color: heartColor,
                        width: 2
                    }
                },
                formatter: `{c} BPM`,
                textStyle: {
                    color: "black",
                    fontWeight: "bold",
                    fontFamily: "Pretendard",
                    fontSize: 13
                }
            },
            xAxis: {
                axisLine: {
                    lineStyle: {
                        width: 1,
                        color: "#dddddd"
                    }
                },
                axisLabel: {
                    color: "#777777",
                    fontWeight: "bold",
                    fontSize: 12,
                    fontFamily: "Pretendard"
                },
                boundaryGap: false,
                data: label1
            },
            yAxis: {
                type: "value",
                axisLabel: {
                    color: "#777777",
                    fontWeight: "bold",
                    fontSize: 12,
                    fontFamily: "Pretendard"
                }
            },
            grid: {
                top: 30,
                left: 50,
                right: 60,
                bottom: 40
            },
            series: [
                {
                    name: "BPM",
                    type: "line",
                    smooth: true,
                    symbol: "none",
                    itemStyle: {
                        color: heartColor,
                        borderWidth: 20,
                        borderType: "solid",
                        opacity: 0.9
                    },
                    lineStyle: {
                        color: heartColor,
                        width: 4
                    },
                    markLine: {
                        symbol: "none",
                        data: [
                            {
                                name: t("정상"),
                                yAxis: data?.heart_range_from ? (data?.heart_range_from + data?.heart_range_to) / 2 : 80,
                                label: {
                                    color: "#3989FF"
                                },
                                lineStyle: {
                                    color: "#3989FF"
                                }
                            },
                            {
                                name: t("경고"),
                                yAxis: data?.heart_range_from ? data?.heart_range_from : 60,
                                label: {
                                    color: "#FC9D3C"
                                },
                                lineStyle: {
                                    color: "#FC9D3C"
                                }
                            },
                            {
                                name: t("위험"),
                                yAxis: data?.heart_range_to ? data?.heart_range_to : 100,
                                label: {
                                    color: "#F75C5D"
                                },
                                lineStyle: {
                                    color: "#F75C5D"
                                }
                            }
                        ],
                        label: {
                            formatter: `{b}`,
                            fontWeight: 700,
                            fontFamily: "Pretendard"
                        },
                        lineStyle: {
                            type: "solid"
                        }
                    },
                    data: values1
                }
            ]
        };
    };

    const getOption2 = () => {
        return {
            tooltip: {
                trigger: "axis",
                axisPointer: {
                    lineStyle: {
                        color: breathColor,
                        width: 2
                    }
                },
                formatter: `{c} ${t("회")}`,
                textStyle: {
                    color: "black",
                    fontWeight: "bold",
                    fontFamily: "Pretendard",
                    fontSize: 13
                }
            },
            xAxis: {
                axisLine: {
                    lineStyle: {
                        width: 1,
                        color: "#dddddd"
                    }
                },
                axisLabel: {
                    color: "#777777",
                    fontWeight: "bold",
                    fontSize: 12,
                    fontFamily: "Pretendard"
                },
                boundaryGap: false,
                data: label2
            },
            yAxis: {
                type: "value",
                axisLabel: {
                    color: "#777777",
                    fontWeight: "bold",
                    fontSize: 12,
                    fontFamily: "Pretendard"
                },
                min: 0,
                max: 40
            },
            grid: {
                top: 30,
                left: 50,
                right: 60,
                bottom: 40
            },
            series: [
                {
                    name: "BPM",
                    type: "line",
                    smooth: true,
                    symbol: "none",
                    itemStyle: {
                        color: breathColor,
                        borderWidth: 20,
                        borderType: "solid",
                        opacity: 0.9
                    },
                    lineStyle: {
                        color: breathColor,
                        width: 4
                    },
                    markLine: {
                        symbol: "none",
                        data: [
                            {
                                name: t("정상"),
                                yAxis: data?.resp_range_from ? (data?.resp_range_from + data?.resp_range_to) / 2 : 15,
                                label: {
                                    color: "#3989FF"
                                },
                                lineStyle: {
                                    color: "#3989FF"
                                }
                            },
                            {
                                name: t("경고"),
                                yAxis: data?.resp_range_from ? data?.resp_range_from : 10,
                                label: {
                                    color: "#FC9D3C"
                                },
                                lineStyle: {
                                    color: "#FC9D3C"
                                }
                            },
                            {
                                name: t("위험"),
                                yAxis: data?.resp_range_to ? data?.resp_range_to : 20,
                                label: {
                                    color: "#F75C5D"
                                },
                                lineStyle: {
                                    color: "#F75C5D"
                                }
                            }
                        ],
                        label: {
                            formatter: `{b}`,
                            fontWeight: 700,
                            fontFamily: "Pretendard"
                        },
                        lineStyle: {
                            type: "solid"
                        }
                    },
                    data: values2
                }
            ]
        };
    };

    const getOption3 = () => {
        return {
            tooltip: {
                trigger: "axis",
                axisPointer: {
                    lineStyle: {
                        color: oxygenColor,
                        width: 2
                    }
                },
                formatter: `{c}`,
                textStyle: {
                    color: "black",
                    fontWeight: "bold",
                    fontFamily: "Pretendard",
                    fontSize: 13
                }
            },
            xAxis: {
                axisLine: {
                    lineStyle: {
                        width: 1,
                        color: "#dddddd"
                    }
                },
                axisLabel: {
                    color: "#777777",
                    fontWeight: "bold",
                    fontSize: 12,
                    fontFamily: "Pretendard"
                },
                boundaryGap: false,
                data: label3
            },
            yAxis: {
                type: "value",
                axisLabel: {
                    color: "#777777",
                    fontWeight: "bold",
                    fontSize: 12,
                    fontFamily: "Pretendard"
                }
            },
            grid: {
                top: 30,
                left: 50,
                right: 60,
                bottom: 40
            },
            series: [
                {
                    name: "BPM",
                    type: "line",
                    smooth: true,
                    symbol: "none",
                    itemStyle: {
                        color: oxygenColor,
                        borderWidth: 20,
                        borderType: "solid",
                        opacity: 0.9
                    },
                    lineStyle: {
                        color: oxygenColor,
                        width: 4
                    },
                    data: values3
                }
            ]
        };
    };

    const isUse = value3 >= 300;
    var iconSet = 0;
    var ser = data.device_sn;

    if (ser) {
        if (ser.startsWith("C", 0)) {
            iconSet = 2;
        } else {
            iconSet = 1;
        }
    }

    const heartClassName = value4 === 1 ? "h-motion-detected" : "heart";
    const breathClassName = value4 === 1 ? "r-motion-detected" : "breath";

    var lng = i18n.language;

    return (
        <main className="sub-contents">
            {lng == "ko" && <audio ref={audioRef} src={ttsAudio} autoPlay />}
            {lng == "en" && <audio ref={audioRef} src={ttsAudio_en} autoPlay />}
            {lng == "jp" && <audio ref={audioRef} src={ttsAudio_jp} autoPlay />}
            {lng == "cn" && <audio ref={audioRef} src={ttsAudio_cn} autoPlay />}
            {lng == "mn" && <audio ref={audioRef} src={ttsAudio_mn} autoPlay />}

            <audio ref={bgmRef} src={BGM} autoPlay loop preload="auto" />

            <div className="inner" style={{ maxWidth: "1420px" }}>
                <div className="progressbar">
                    <h2>{t("측정중")}</h2>
                    <Progress percent={percent} strokeColor={"#f08c26"} showInfo={false} strokeLinecap="round" size={[1040, 60]} style={{ margin: 0 }} strokeColor={{ from: "#108ee9", to: "#87d068" }} />
                </div>

                <section className="monitoring_signal_list">
                    <ul>
                        <li className={heartClassName}>
                            <p className="title">
                                <b>{t("심박수")}</b>(BPM)
                            </p>
                            <p className="data">
                                <strong>{value1}</strong> BPM
                            </p>
                        </li>
                        <li className={breathClassName}>
                            <p className="title">
                                <b>{t("호흡수")}</b>(BPM)
                            </p>
                            <p className="data">
                                <strong>{value2}</strong> BPM
                            </p>
                        </li>
                        <li className="oxygen">
                            <p className="title">
                                <b>{t("사용 여부")}</b>
                            </p>
                            <p className="data">
                                <strong>{data.online ? (isUse ? (value4 === 1 ? t("움직임 감지") : t("사용 중")) : t("미사용")) : t("OFF")}</strong>
                            </p>
                        </li>
                    </ul>
                </section>

                <section className="monitoring_time_graph">
                    <h4>{t("실시간 생체신호")}</h4>

                    <div className="graph_wrap">
                        <article className="graph_arti heart_graph">
                            <div className="top">
                                <span>
                                    <em></em> {t("심박수")}
                                </span>
                                <span>
                                    {t("정상 심박수 범위")} : {data?.heart_range_from ? data?.heart_range_from : 60}-{data?.heart_range_to ? data?.heart_range_to : 100} BPM
                                </span>
                            </div>
                            <div className="graph_box">
                                <ECharts option={getOption1()} opts={{ renderer: "svg", width: "auto" }} />
                            </div>
                        </article>

                        <article className="graph_arti breath_graph">
                            <div className="top">
                                <span>
                                    <em></em> {t("호흡수")}
                                </span>
                                <span>
                                    {t("정상 호흡수 범위")} : {data?.resp_range_from ? data?.resp_range_from : 10}~{data?.resp_range_to ? data?.resp_range_to : 20}
                                    BPM
                                </span>
                            </div>
                            <div className="graph_box">
                                <ECharts option={getOption2()} opts={{ renderer: "svg", width: "auto" }} />
                            </div>
                        </article>

                        <article className="graph_arti oxygen_graph">
                            <div className="top">
                                <span>
                                    <em></em> {t("입력값")}
                                </span>
                                <span>{data.online ? "300 < " + (isUse ? (value4 === 1 ? t("움직임 감지") : t("사용 중")) : t("미사용")) : ""}</span>
                            </div>
                            <div className="graph_box">
                                <ECharts option={getOption3()} opts={{ renderer: "svg", width: "auto" }} />
                            </div>
                        </article>
                    </div>
                </section>
            </div>
        </main>
    );
};

export default Start;
